import { render, staticRenderFns } from "./TimeFieldtype.vue?vue&type=template&id=863eec72&"
import script from "./TimeFieldtype.vue?vue&type=script&lang=js&"
export * from "./TimeFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports